import { Button, Icon, Modal, Shimmer, Text } from '@pukka/ui-components';

interface ReactivateOutletModalProps {
  readonly name: string;
  readonly packages?: string;
  readonly period?: string;
  readonly price?: string;
  readonly suffix?: string;
  readonly open?: boolean;
  readonly loading?: 'activation' | 'immediate' | true;
  readonly onToggleModal?: (open: boolean) => void;
  readonly onActivateNextPayment?: () => void;
  readonly onImmediateActivate?: () => void;
}

function ReactivateOutletModal({
  name,
  packages,
  period,
  price,
  suffix,
  open,
  loading,
  onToggleModal,
  onActivateNextPayment,
  onImmediateActivate,
}: ReactivateOutletModalProps) {
  return (
    <Modal size="lg" unwrap open={open} onOpenChange={onToggleModal}>
      <Modal.Content>
        <Modal.Title className="flex-row justify-between">
          Re-activate Outlet?
          <Modal.Trigger asChild>
            <Button variant="nude" size="none" className="rounded-md">
              <Icon icon="close" color="white" />
            </Button>
          </Modal.Trigger>
        </Modal.Title>
        <Modal.Body className="mb-6 mt-4 max-h-128 px-8">
          <Text variant="subtitle-1" className="p-3 text-neutral-600">
            Would you like to activate it immediately (with pro-rated calculation) or delay activation until the next term payment? If you
            choose immediate activation, you will be redirected to the payment page.
          </Text>
          <Text variant="body-2" color="primary" weight="medium" className="mt-4 p-4">
            Pro-rated Calculation
          </Text>
          <div className="flex flex-row justify-between px-2.5 py-3">
            <div className="px-2">
              <Text variant="body-2" color="primary">
                {name}
              </Text>
              {packages ? (
                <Text variant="caption-2" className="text-neutral-600">
                  Package: {packages}
                </Text>
              ) : (
                <Shimmer size="sm" className="w-56" />
              )}
              {period ? (
                <Text variant="caption-2" className="text-neutral-400">
                  price is pro-rated for period from {period}
                </Text>
              ) : (
                <Shimmer size="sm" className="w-80" />
              )}
            </div>
            <div className="flex flex-col justify-center px-2">
              {price === undefined && suffix === undefined ? (
                <Shimmer size="xxl" className="w-36" />
              ) : (
                <Text variant="subtitle-2" weight="medium" className="text-neutral-600">
                  {price}
                  {suffix}
                </Text>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex flex-1" />
          <Modal.Button variant="secondary" loading={loading === 'activation'} disabled={!!loading} onClick={onActivateNextPayment}>
            Activate Next Payment
          </Modal.Button>
          <Modal.Button loading={loading === 'immediate'} disabled={!!loading} onClick={onImmediateActivate}>
            Immediate Activate
          </Modal.Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}

export { ReactivateOutletModal };
